<!-- <div class="flex">
  <div class="flex w-[200px] flex-col p-3">
    <span
      *ngFor="let component of components"
      class="cursor-pointer"
      (click)="currentComponent = component">
      {{ component }}
    </span>
  </div>
  <div class="flex-1 p-3">
    <ng-container [ngSwitch]="currentComponent">
      <div *ngSwitchCase="components[0]">
        <div class="grid grid-cols-5 gap-4">
          <p class="prose prose-display-lg"></p>
          <p class="prose prose-display-lg">font-regular</p>
          <p class="prose prose-display-lg font-medium">font-medium</p>
          <p class="prose prose-display-lg font-semibold">font-semibold</p>
          <p class="prose prose-display-lg font-bold">font-bold</p>
          <p class="prose prose-display-lg">font-size: 32px</p>
          <p class="prose prose-display-lg">prose-display-lg</p>
          <p class="prose prose-display-lg font-medium">prose-display-lg</p>
          <p class="prose prose-display-lg font-semibold">prose-display-lg</p>
          <p class="prose prose-display-lg font-bold">prose-display-lg</p>
          <p class="prose prose-display-md">font-size: 28px</p>
          <p class="prose prose-display-md">prose-display-md</p>
          <p class="prose prose-display-md font-medium">prose-display-md</p>
          <p class="prose prose-display-md font-semibold">prose-display-md</p>
          <p class="prose prose-display-md font-bold">prose-display-md</p>
          <p class="prose prose-display-sm">font-size: 24px</p>
          <p class="prose prose-display-sm">prose-display-md</p>
          <p class="prose prose-display-sm font-medium">prose-display-md</p>
          <p class="prose prose-display-sm font-semibold">prose-display-md</p>
          <p class="prose prose-display-sm font-bold">prose-display-md</p>
          <p class="prose prose-display-xs">font-size: 20px</p>
          <p class="prose prose-display-xs">prose-display-xs</p>
          <p class="prose prose-display-xs font-medium">prose-display-xs</p>
          <p class="prose prose-display-xs font-semibold">prose-display-xs</p>
          <p class="prose prose-display-xs font-bold">prose-display-xs</p>
          <p class="prose prose-text-xl">font-size: 18px</p>
          <p class="prose prose-text-xl">prose-text-xl</p>
          <p class="prose prose-text-xl font-medium">prose-text-xl</p>
          <p class="prose prose-text-xl font-semibold">prose-text-xl</p>
          <p class="prose prose-text-xl font-bold">prose-text-xl</p>
          <p class="prose prose-text-md">font-size: 16px</p>
          <p class="prose prose-text-md">prose-text-md</p>
          <p class="prose prose-text-md font-medium">prose-text-md</p>
          <p class="prose prose-text-md font-semibold">prose-text-md</p>
          <p class="prose prose-text-md font-bold">prose-text-md</p>
          <p class="prose prose-text-sm">font-size: 14px</p>
          <p class="prose prose-text-sm">prose-text-sm</p>
          <p class="prose prose-text-sm font-medium">prose-text-sm</p>
          <p class="prose prose-text-sm font-semibold">prose-text-sm</p>
          <p class="prose prose-text-sm font-bold">prose-text-sm</p>
          <p class="prose prose-text-xs">font-size: 12px</p>
          <p class="prose prose-text-xs">prose-text-xs</p>
          <p class="prose prose-text-xs font-medium">prose-text-xs</p>
          <p class="prose prose-text-xs font-semibold">prose-text-xs</p>
          <p class="prose prose-text-xs font-bold">prose-text-xs</p>
          <p class="prose prose-caption">font-size: 10px</p>
          <p class="prose prose-caption">prose-caption</p>
          <p class="prose prose-caption font-medium">prose-caption</p>
          <p class="prose prose-caption font-semibold">prose-caption</p>
          <p class="prose prose-caption font-bold">prose-caption</p>
        </div>
      </div>
      <div *ngSwitchCase="components[1]">
        <div class="grid grid-cols-3 gap-4">
          <div><button app-button>app-button</button></div>
          <div><button app-button color="secondary">app-button color="secondary"</button></div>
          <div><button app-button color="tertiary">app-button color="tertiary"</button></div>
          <div><button app-button disabled>app-button disabled</button></div>
          <div>
            <button app-button color="secondary" disabled>
              app-button color="secondary" disabled
            </button>
          </div>
          <div>
            <button app-button color="tertiary" disabled>
              app-button color="tertiary" disabled
            </button>
          </div>
          <div><button app-button size="sm">app-button size="sm"</button></div>
          <div>
            <button app-button size="sm" color="secondary">
              app-button size="sm" color="secondary"
            </button>
          </div>
          <div>
            <button app-button size="sm" color="tertiary">
              app-button size="sm" color="tertiary"
            </button>
          </div>
          <div><button app-button size="sm" disabled>app-button size="sm" disabled</button></div>
          <div>
            <button app-button size="sm" color="secondary" disabled>
              app-button size="sm" color="secondary" disabled
            </button>
          </div>
          <div>
            <button app-button size="sm" color="tertiary" disabled>
              app-button size="sm" color="tertiary" disabled
            </button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="components[2]">
        <div class="grid grid-cols-3 gap-4">
          <div>
            <div>app-icon-button name="x" size="sm"</div>
            <button app-icon-button name="x" size="sm"></button>
          </div>
          <div>
            <div>app-icon-button name="x"</div>
            <button app-icon-button name="x"></button>
          </div>
          <div>
            <div>app-icon-button name="x" size="lg"</div>
            <button app-icon-button name="x" size="lg"></button>
          </div>
          <div>
            <div>app-icon-button name="x" size="sm" disabled</div>
            <button app-icon-button name="x" size="sm" disabled></button>
          </div>
          <div>
            <div>app-icon-button name="x" disabled</div>
            <button app-icon-button name="x" disabled></button>
          </div>
          <div>
            <div>app-icon-button name="x" size="lg" disabled</div>
            <button app-icon-button name="x" size="lg" disabled></button>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="components[3]">
        <div class="flex gap-4">
          <app-badge color="fill-color">Label</app-badge>
          <app-badge color="stroke">Label</app-badge>
          <app-badge color="fill">Label</app-badge>
        </div>
      </div>
      <div *ngSwitchCase="components[4]">
        <div class="flex gap-4">
          <app-avatar src="/assets/images/avatar.svg"></app-avatar>
          <app-avatar name="Su Bui"></app-avatar>
          <app-avatar size="lg" src="/assets/images/avatar.svg"></app-avatar>
          <app-avatar size="lg" name="Su Bui"></app-avatar>
        </div>
      </div>
      <div *ngSwitchCase="components[5]">
        <div class="flex flex-col gap-4">
          <div class="flex gap-4">
            <span>Radio single</span>
            <app-radio [(ngModel)]="radioChecked">Label</app-radio>
            <span>Checked: {{ radioChecked }}</span>
          </div>
          <div class="flex gap-4">
            <span>Radio group</span>
            <app-radio-group class="flex gap-2" [(ngModel)]="radio">
              <app-radio value="option 1">Option 1</app-radio>
              <app-radio value="option 2">Option 2</app-radio>
              <app-radio value="option 3" [disabled]="true">Option 3</app-radio>
            </app-radio-group>
            <span>Value: {{ radio }}</span>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="components[6]">
        <div class="flex flex-col gap-4">
          <div class="flex gap-4">
            <app-checkbox [(ngModel)]="checkboxChecked">Label</app-checkbox>
            <span>Checked: {{ checkboxChecked }}</span>
          </div>
          <div>
            <app-checkbox [disabled]="true">Label disabled</app-checkbox>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="components[7]">
        <div class="flex gap-4">
          <app-toggle [(ngModel)]="toggle">Label</app-toggle>
          <span>Toggle: {{ toggle }}</span>
        </div>
      </div>
      <div *ngSwitchCase="components[8]">
        <div class="grid grid-cols-3 gap-4">
          <input app-input title="Input title" />
          <input app-input title="Input title" required />
          <input app-input title="Input title" [suffixIcon]="icon" />
          <ng-template #icon>
            <app-icon name="eye" [fontSize]="20"></app-icon>
          </ng-template>
        </div>
      </div>
      <div *ngSwitchCase="components[9]">
        <div class="flex flex-col">
          <div class="flex gap-2">
            <app-icon name="user-circle"></app-icon>
            <app-icon name="user-circle" fontSize="16" color="red"></app-icon>
            <app-icon name="user-circle" fontSize="48" class="text-success-500"></app-icon>
          </div>
          <div class="flex gap-2">
            <app-flag name="us"></app-flag>
            <app-flag name="cn"></app-flag>
            <app-flag name="hk"></app-flag>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="components[10]">
        <div class="grid grid-cols-4 gap-5">
          <div class="flex flex-col gap-3">
            Required
            <app-select
              [(ngModel)]="selectedDropdownOption1"
              [label]="'Select Dropdown'"
              required
              multiple>
              <app-option value="value1">label1</app-option>
              <app-option value="value2">label2</app-option>
              <app-option value="value3">label3</app-option>
            </app-select>
            Value: {{ selectedDropdownOption1 }}
          </div>
          <div class="flex flex-col gap-3">
            No Required
            <app-select [(ngModel)]="selectedDropdownOption2" [label]="'Select Dropdown'">
              <app-option value="value1">label1</app-option>
              <app-option value="value2">label2</app-option>
              <app-option value="value3">label3</app-option>
            </app-select>
            Value: {{ selectedDropdownOption2 }}
          </div>
          <div class="flex flex-col gap-3">
            Disabled
            <app-select [(ngModel)]="selectedDropdownOption1" [label]="'Select Dropdown'" disabled>
              <app-option value="value1">label1</app-option>
              <app-option value="value2">label2</app-option>
              <app-option value="value3">label3</app-option>
            </app-select>
          </div>
        </div>
      </div>
      <div *ngSwitchCase="components[11]" class="h-96">
        <app-navigation [(navPageIndex)]="page">
          <app-nav-page navLink="/auth/login">
            <div app-nav-page-title>Page 1</div>
            <div app-nav-page-subtitle>
              Please enter the OTP sent to +84 *** *** **56.<br />
              If you did not receive the OTP, click “Re-send OTP” after 30 seconds.
            </div>
            <button app-button (click)="page = page + 1">Next</button>
          </app-nav-page>
          <app-nav-page>
            <div app-nav-page-title>Page 2</div>
            <div app-nav-page-subtitle>
              Please enter the OTP sent to +84 *** *** **56.<br />
              If you did not receive the OTP, click “Re-send OTP” after 30 seconds.
            </div>
            <button app-button (click)="page = page + 1">Next</button>
          </app-nav-page>
          <app-nav-page>
            <div app-nav-page-title>SMS OTP verification</div>
            <div app-nav-page-subtitle>
              Please enter the OTP sent to +84 *** *** **56.<br />
              If you did not receive the OTP, click “Re-send OTP” after 30 seconds.
            </div>
            <div>Last page</div>
          </app-nav-page>
        </app-navigation>
      </div>
      <div *ngSwitchDefault></div>
    </ng-container>
  </div>
</div> -->
<div class="flex h-dvh flex-col">
  <div class="flex flex-1 flex-col items-center justify-center gap-10 overflow-y-auto">
    <input type="file" accept=".jpg, .jpeg, .png, .pdf, .doc, .docx" />
  </div>
  <button app-button (click)="window_alert()">Submit</button>
</div>
